import { RSAA } from 'redux-api-middleware';
import {
	MANDATE_TYPE_STANDING_ORDER,
	MANDATE_TYPE_DIRECT_DEBIT,
	MANDATE_TYPE_SCHEDULE_PAYMENT,
	MANDATE_TYPE_SCHEDULE_TRANSFER,
	MANDATE_TYPE_CHAPS,
} from '../../config';
import endpoints from '../../utils/endpoints';

export const CANCEL_MANDATE_API_CALL = 'CANCEL_MANDATE_API_CALL';
export const CANCEL_MANDATE_SUCCESS = 'CANCEL_MANDATE_SUCCESS';
export const CANCEL_MANDATE_FAILURE = 'CANCEL_MANDATE_FAILURE';
export const SHOW_CANCEL_MANDATE_VIEW = 'SHOW_CANCEL_MANDATE_VIEW';
export const HIDE_CANCEL_MANDATE_VIEW = 'HIDE_CANCEL_MANDATE_VIEW';

export const handleShowCancelModal = (mandate) => ({
	type: SHOW_CANCEL_MANDATE_VIEW,
	mandate,
	showCancelModal: true,
});

export const handleHideCancelModal = () => ({
	type: HIDE_CANCEL_MANDATE_VIEW,
	showCancelModal: false,
});

export const getCancelMandateEndPoint = ({ id: mandateId, mandateType, fromAccount: { accountId } }) => {
	if (
		[
			MANDATE_TYPE_STANDING_ORDER,
			MANDATE_TYPE_DIRECT_DEBIT,
			MANDATE_TYPE_SCHEDULE_PAYMENT,
			MANDATE_TYPE_SCHEDULE_TRANSFER,
		].includes(mandateType)
	) {
		const type = mandateType === MANDATE_TYPE_DIRECT_DEBIT ? 'dd' : 'so';
		return {
			...endpoints.cancelPayments,
			uri: endpoints.cancelPayments.resolve(null, null, accountId, mandateId, type),
		};
	}
	const endpoint = endpoints.cancelBacsPayment.resolve(null, null, accountId, mandateId);
	const uri = mandateType === MANDATE_TYPE_CHAPS ? `${endpoint}?context=uuid` : endpoint;
	return {
		...endpoints.cancelBacsPayment,
		uri,
	};
};

export const cancelMandate = (mandate) => {
	const endpoint = getCancelMandateEndPoint(mandate);
	return {
		[RSAA]: {
			endpoint: endpoint.uri,
			method: endpoint.method,
			types: [CANCEL_MANDATE_API_CALL, CANCEL_MANDATE_SUCCESS, CANCEL_MANDATE_FAILURE],
			headers: { 'x-bpi-version': endpoint.x_bpi_version },
		},
	};
};
export const handleCancelMandate = (mandate) => (dispatch) => dispatch(cancelMandate(mandate));
